// extracted by mini-css-extract-plugin
export default {"thumbsUp":"MessageFeedbackDialog-module__thumbsUp--go17F","thumbsDown":"MessageFeedbackDialog-module__thumbsDown--sluhP"};